import React, { useState, useEffect } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "./designs.css";
import "@splidejs/react-splide/css";
import { Link } from "react-router-dom";

const Sliders = (props) => {
  const [popularMovies, setPopularMovies] = useState([]);

  // API CALLING USING USEEFFECT

  useEffect(() => {
    // setIsLoading(true);
    fetch(
      "https://api.themoviedb.org/3/movie/popular?api_key=375735221c3b7b45a786c79616eae571&language=en-US"
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.results);
        setPopularMovies(data.results);
        // setIsLoading(false);
      });
  }, []);

  return (
    <div className="main-design-one">
      <p
        // className="title-section"
        style={{ color: "white", fontSize: 20, fontWeight: 700 }}
      >
        {props.title}
      </p>
      <Splide
        options={{
          perPage: 6,
          // type: "loop",
          drag: "free",
          perMove: 1,
          pagination: false,
          gap: "0.2rem",
          breakpoints: {
            640: {
              perPage: 2,
              width: 400,
              height: 400,
              pagination: false,
            },
            450: {
              perPage: 2,
              width: "100%",
              height: 300,
              pagination: false,

              // arrows: false,
            },
          },
        }}
      >
        {popularMovies.map((movie) => (
          <SplideSlide>
            <Link key={movie.id} to={`/movie/${movie.id}`}>
              <div className="card-design">
                <img
                  className="card-image"
                  src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                  alt="movie"
                />
                <div className="card__content">
                  <p className="card-title">{movie.original_title}</p>
                  <p className="card_rating">
                    {" "}
                    {movie.vote_average} <i className="fa fa-star"></i>
                  </p>
                  <p className="card_desc">{movie.overview}</p>
                </div>
              </div>
            </Link>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

export default Sliders;
